module.exports = __webpack_public_path__ + "img/logoLR_yoko.75b3e787.svg";